import { NotFound, ProtectedRoute } from "@fdoh/health-ui-react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import SubmitInspectionForm from "./SubmitInspection";

export const SubmitInspectionModule = () => {
  let { path } = useRouteMatch();

  return (
    
      <Switch>
        <ProtectedRoute exact path={path}>
              <SubmitInspectionForm />
        </ProtectedRoute> 
        {/* <ProtectedRoute exact path={`${path}/:id(\\d+)`}>
          <EditSetBacksPage />
        </ProtectedRoute>  */}
        <Route>
          <NotFound />
        </Route>
      </Switch>
    
  );
};

export default SubmitInspectionModule;
